import React from "react";
import axios from "../../api/axios";
import useAuth from "../../hooks/useAuth";
import PhotoCarousel from "./PhotoCarousel";
import PhotoCarouselEdit from "./PhotoCarouselEdit";
import { t } from "i18next";
const WEBSITE_URL = "/dashboard/key";

export default function FloorPlan() {
  const [showFloorPlan, setShowFloorPlan] = React.useState(false);
  const { username, auth } = useAuth();

  React.useEffect(() => {
    const fetchSetting = async () => {
      try {
        const res = await axios.get(WEBSITE_URL, {
          params: {
            username,
            key: "showFloorPlan",
          },
        });

        setShowFloorPlan(Boolean(res.data.showFloorPlan));
      } catch (error) {
        console.error("Error loading showFloorPlan:", error);
      }
    };

    fetchSetting();
  }, [username]);

  if (!showFloorPlan) return null;

  return (
    <div className="slow-carousel-section">
      <h2>{t("accommodation_page.floorPlan")}</h2> 

      {!auth?.role ? (
        <PhotoCarousel title="accommodation-extra" />
      ) : (
        <PhotoCarouselEdit title="accommodation-extra" />
      )}
    </div>
  );
}
